import React, { useState } from "react";
import { navigate } from "gatsby";
import Modal from "../Modal/modal";
import plusBp from "../../../images/icons/plusBp.svg";
import AddBP from "./AddBP";
const AddBpButton = () => {
	const [show, setShow] = useState(false);

	return (
		<div
			onClick={() => {
				setShow(true);
			}}
			className=" w-56 h-12 mr-7 mt-2 cursor-pointer text-center text-tealCol-100 border-2 border-tealCol-100 rounded-md"
		>
			<div className="mx-auto pt-3 pb-3 inline-flex ">
				<img className="block mr-2 -mt-px" src={plusBp} alt="+" />
				<span className="text-base text-left  block font-roboto font-normal">
					Add Business Partner
				</span>
			</div>
			<Modal show={show} setShow={setShow}>
				<AddBP setShow={setShow} />
			</Modal>
		</div>
	);
};
export default AddBpButton;
